import type { CountryCode } from "libphonenumber-js";

export enum SupportedCountry {
  UnitedStates = "US",
}

export type ICountryConfig = {
  code: CountryCode;
  name: string;
  flag: string;
  callingCode: string;
};

export type IParsedPhoneValue = {
  country: CountryCode;
  code: string;
  number: string;
};
